import { CashRegisterMoneyModelType } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney'
import { CashRegisterMoneyLogModelType } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney/cashRegisterMoneyLog'
import { useMemo } from 'react'
import { DisplayPriceGettingParams } from '../../../../../../../../baseComponents/Displays/DisplayPrice'
import { CloseLateralModalSimple, ModalMediumCenteredLoading } from '../../../../../../../../baseComponents/Modal'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { CustomRenderDateHours, CustomRenderString } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import TwinToolTip from '../../../../../../../../baseComponents/TwinToolTip'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import CashReghisterMoneyLogNameBoxTPV from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/CashRegisterMoneyLogNameBoxTPV'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getISOCurrencyMain, getPaymentTypes } from '../../../../../../../../utils/reducers/getters'
import '../modalMoneyCashInOutTPVDSB.sass'


interface ModalCashRegisterMoneyLogsProps {
    setOpenModal: SetEditDeleteModalTy
    allRowData?: RowData
}

interface CashRegisterMoneyLogModelTypeExtended extends CashRegisterMoneyLogModelType {
    CashRegisterMoney: CashRegisterMoneyModelType
}

const ModalCashRegisterMoneyLogs: React.FC<ModalCashRegisterMoneyLogsProps> = ({ setOpenModal, ...logic }) => {
    const { t } = useTwinTranslation()
    const paymentTypes = getPaymentTypes()
    const dictTypeRegister: TwinDictionary = {
        0: { name: t('cashOpening', 'Apertura de caja')},
        1: { name: t('cashClosing', 'Cierre de caja')},
        2: {name: t('ticket', 'Ticket')},
        3: {name: t('refund', 'Devolución')},
        4: {name: t('cashIn', 'Entrada de caja')},
        5: { name: t('cashOut', 'Salida de caja') },
        6: { name: t('regularization', 'Regularización') },
    }
    const mainCurrencyId = getISOCurrencyMain()
    const dictPaymentTypesTPV = useMemo(() => dictionaryComplexFromJsonArr(paymentTypes?.activeTpv || []), [paymentTypes?.activeTpv])
    const columns: ColumnTableSchema<CashRegisterMoneyLogModelTypeExtended> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('paymentMethod', 'Método de pago'),
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: dictPaymentTypesTPV, label: t('paymentMethod', 'Método de pago'),  }
            },
            generalSearchable: false,
            searchSingleKey: 'CashRegisterMoney.PaymentTypeId',
            customRender: (parameterValue, allRowData) => <CashReghisterMoneyLogNameBoxTPV icon={paymentTypes?.all[allRowData?.CashRegisterMoney?.PaymentTypeId]?.icon || ''} name={paymentTypes?.all[allRowData?.CashRegisterMoney?.PaymentTypeId]?.name || ''} />
        },
        {
            id: 'createdAt',
            dataKey: 'createdAt',
            label: t('date', 'Fecha'),
            sortable: true,
            customRender: (parameterValue) => <CustomRenderDateHours value={parameterValue} />
        },
        {
            id: 'operationType',
            dataKey: 'operationType',
            label: t('typeOperation', 'Tipo de operación'),
            searchableComponent: {
                component: 'SearchableComponentsCustomSelect',
                extraComponentData: { items: dictTypeRegister || {}, label: t('typeOperation', 'Tipo de operación') }
            },
            searchKey: 'operationType',
            customRender: (parameterValue) => <CustomRenderString value={dictTypeRegister[parameterValue || 0].name} />
        },
        {
            id: 'SellTicketId',
            dataKey: 'SellTicketId',
            label: t('information', 'Información'),
            width: 150,
            customRender: (parameterValue, allRowData) => <ReasonCashRegisterLog allRowData={allRowData} value={parameterValue} />,
            searchKey: 'SellTicket.full_assigned_number',
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('ticket', 'Ticket') }
            },
        },
        {
            hideColumnByDefault: true,
            justForFilter: true,
            id: 'RefundId',
            dataKey: 'SellTicketId',
            label: t('information', 'Información'),
            width: 150,
            customRender: (parameterValue, allRowData) => <ReasonCashRegisterLog allRowData={allRowData} value={parameterValue} />,
            searchKey: 'SellTicketRefund.full_assigned_number',
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('ticket', 'Ticket') }
            },
        },
        {
            id: 'money',
            dataKey: 'money',
            label: t('operation', 'Operación'),
            width: 120,
            customRender: (parameterValue, allRowData) => <div className='flex'>{parseFloat(parameterValue) > 0 ? '+' : ''}<DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={false} CurrencyId={paymentTypes?.all[allRowData?.CashRegisterMoney?.PaymentTypeId]?.extraData?.CurrencyId || mainCurrencyId} /></div>,
        },
        {
            id: 'endMoney',
            dataKey: 'endMoney',
            label: t('total', 'Total'),
            width: 120,
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={false} CurrencyId={paymentTypes?.all[allRowData?.CashRegisterMoney?.PaymentTypeId]?.extraData?.CurrencyId || mainCurrencyId} />,
        },
    ]
        
    return (
        <ModalMediumCenteredLoading loading={false} className='modal_cash_register_logs ' opened={true} setOpened={() => setOpenModal(null)} onClickOut={true}>
            <CloseLateralModalSimple onClose={() => setOpenModal(null)} />
            <h2 className='mb-20'><TwinTrans transKey='cashRegisterLogs'>Registro de caja</TwinTrans></h2>
            <TwinTable name='cashRegisterMoneyLogs' columns={columns} defaultOrder={{ order: 'desc', defaultOrderField: 'createdAt' }} getDataFrom='/api/app/order/tpv/cashRegister/cashRegisterMoney/getAllCashRegisterMoneyLogsByCashRegister'
                extraWhereParams={{ 'CashRegisterMoney.CashRegisterId': logic?.allRowData?.CashRegisterId }} hideChangeColumnsButton={true} />
        </ModalMediumCenteredLoading>
    )
}

interface ReasonCashRegisterLogProps {
    allRowData: RowData
    value: any
}

const ReasonCashRegisterLog: React.FC<ReasonCashRegisterLogProps> = ({ value, allRowData }) => {
    let reason = allRowData?.SellTicket?.full_assigned_number || allRowData?.RegularizeSellTicket?.full_assigned_number || ''
    if (!value && allRowData?.extraData?.notes) {
        reason = allRowData?.extraData?.notes || ''
    } else if (allRowData?.SellTicketRefund?.full_assigned_number) {
        reason += ' / ' + allRowData?.SellTicketRefund?.full_assigned_number
    } else if (allRowData?.PartialChargeSellTicket?.full_assigned_number) {
        reason += ' / ' + allRowData?.PartialChargeSellTicket?.full_assigned_number
    }
    return (
        <div className='overflow-hidden'>
            <TwinToolTip id={'reason' + allRowData.id} content={reason} className='max-w-300' />
            <div className='twin_elipsis' data-tooltip-id={'reason' + allRowData.id}>{reason}</div>
        </div>
    )
}


export default ModalCashRegisterMoneyLogs